import { z } from "zod";
import { ServerGenericSearchProps } from "~/components/GenericSearch/GenericSearch";
import { SearchBlock } from "~/components/LandingPageV2/schemas";
import { getValueOrDefault } from "~/lib/shared/getValueOrDefault";
import { heDecodeOrDefault } from "~/lib/shared/html-utils/heDecodeOrDefault";
import { OptionData } from "~/ui-library/components/Select";

const CLEAR_ITEM: OptionData = { id: "", label: "All" };

export const apiToGenericSearchProps = ({
  categoryOptions,
  contentTypeOptions,
  topicOptions,
  pageSize,
  sectionTitle,
  hideSideFilters,
}: Omit<
  SearchBlock,
  "acfFcLayout" | "appearance" | "maxWidth"
>): ServerGenericSearchProps => ({
  categoryOptions: [CLEAR_ITEM].concat(
    categoryOptions
      .sort(({ name: labelOne }, { name: labelTwo }) =>
        labelOne.localeCompare(labelTwo)
      )
      .map<OptionData>(({ id, name }) => ({
        id: z.coerce.string().parse(id),
        label: heDecodeOrDefault(name),
      }))
  ),
  contentTypeOptions: [CLEAR_ITEM].concat(
    contentTypeOptions
      .sort(({ label: labelOne }, { label: labelTwo }) =>
        labelOne.localeCompare(labelTwo)
      )
      .map<OptionData>(({ value, label }) => ({
        id: z.coerce.string().parse(value),
        label: heDecodeOrDefault(label),
      }))
  ),
  topicOptions: topicOptions
    .sort(({ name: labelOne }, { name: labelTwo }) =>
      labelOne.localeCompare(labelTwo)
    )
    .map(({ id, name }) => ({
      id: z.coerce.string().parse(id),
      label: heDecodeOrDefault(name),
    })),
  pageSize: z.coerce.number().int().parse(getValueOrDefault(pageSize, "12")),
  sectionTitle: getValueOrDefault(sectionTitle, ""),
  hideSideFilters: Boolean(hideSideFilters),
});
